import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './app/shared/components/loader/loader.component';
import { ToastComponent } from './app/shared/components/toast/toast.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoaderComponent, ToastComponent],
    template: `
        <app-loader></app-loader>
        <app-toast></app-toast>
        <router-outlet></router-outlet>
    `
})
export class AppComponent {}
